<template>
  <div>
    <v-container
      fluid
      style="overflow:hidden; position:relative"
      class="pl-sm-12 pr-sm-12"
    >
      <p class="primary--text pa-4 display-1 font-weight-bold pt-10">
        Buscador
      </p>
      <v-img
        :src="pejeperra"
        height="200"
        width="400"
        contain
        class="d-none d-sm-flex"
        style="position: absolute; top: 100px; right: -50px; filter: opacity(20%)"
      ></v-img>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card class="ma-2 mt-0 mb-4" color="transparent" flat>
            <v-card-title class="title">
              <span class="primary--text font-weight-bold">Filtros</span>
            </v-card-title>
            <div class="pa-4 pt-0">
              <v-card flat color="transparent" width="290">
                <v-menu
                  ref="menuDatePicker"
                  v-model="menuDatePicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on }">
                    <div>
                      <v-text-field
                        class="mb-4 mt-4"
                        label="Fecha"
                        :value="computedDateFormattedDatefns"
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        hide-details
                        rounded
                        outlined
                        v-on="on"
                      >
                        <template v-slot:prepend-inner>
                          <SvgIcon
                            icon="cp-event-date"
                            height="20px"
                            fill="#004480"
                          ></SvgIcon>
                        </template>
                      </v-text-field>
                    </div>
                  </template>
                  <v-date-picker
                    no-title
                    @input="menuDatePicker = false"
                    range
                    v-model="filterData.eventDate"
                  ></v-date-picker>
                </v-menu>
              </v-card>
              <v-card flat color="transparent" max-width="690">
                <div>
                  <v-autocomplete
                    class="mb-2 mt-4"
                    v-model="filterData.organism"
                    :items="organismList"
                    item-value="id"
                    label="Especie"
                    hide-details
                    no-filter
                    outlined
                    multiple
                    rounded
                    return-object
                    :search-input.sync="searchTextOrganism"
                  >
                    <template v-slot:prepend-inner>
                      <SvgIcon
                        icon="cp-fish-1"
                        height="20px"
                        fill="#004480"
                      ></SvgIcon>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        close
                        outlined
                        class="mb-1 mt-1"
                        color="secondary"
                        @click:close="removeOrganismList(data.item)"
                      >
                        <v-avatar left color="white">
                          <OrganismProfilePicture
                            :id="data.item.id"
                          ></OrganismProfilePicture>
                        </v-avatar>
                        <span class="line-clamp-1">
                          <span class="body-1 font-weight-medium">{{
                            data.item.vernacularName
                          }}</span>
                          <span class="ml-2 mr-2">-</span>
                          <span class="caption" style="font-style:italic">{{
                            data.item.scientificName
                          }}</span>
                        </span>
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-avatar left color="white">
                        <OrganismProfilePicture
                          :id="data.item.id"
                        ></OrganismProfilePicture>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          class="font-weight-medium"
                          v-html="data.item.vernacularName"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-html="data.item.scientificName"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </div>
              </v-card>
              <v-btn
                @click="cleanFilter"
                color="primary"
                rounded
                large
                class="mt-4"
                >Limpiar filtros</v-btn
              >
            </div>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card class="ma-2 mt-0 mb-4 rounded-custom">
            <LMap
              :zoom="zoom"
              :center="center"
              ref="map"
              @update:bounds="boundsUpdated"
              style="z-index:0; height:500px"
            >
              <LMarker
                v-for="(marker, index) of markerList"
                :lat-lng="marker.latLng"
                :key="index"
              ></LMarker>
            </LMap>
          </v-card>
          <div class="d-flex flex justify-center mt-8">
            <v-btn
              v-if="filterData.polygonCoordinates"
              @click="stopDrawer"
              color="#009c5e"
              width="280"
              dark
              large
              rounded
            >
              <v-icon left>mdi-close</v-icon>
              <span>Limpiar selección</span>
            </v-btn>
            <v-btn
              v-else
              @click="startDrawer"
              color="#009c5e"
              width="280"
              rounded
              large
              dark
            >
              <SvgIcon icon="cp-map-area" fill="white" height="30px"></SvgIcon>
              <span class="pl-3">Marcar área</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-divider class="primary mt-8 mb-8"></v-divider>
      <div>
        <!-- <EventCardGraphs :event="listGraphs"></EventCardGraphs> -->
        <EventCardGraphs :event="listGraphs"></EventCardGraphs>

        <v-divider class="primary mt-8 mb-4"></v-divider>

        <v-subheader class="title primary--text font-weight-bold"
          >Resultados de la búsqueda</v-subheader
        >

        <div v-if="loading">
          <v-row class="pa-4 pt-0">
            <v-col
              cols="12"
              md="6"
              lg="4"
              v-for="(item, index) of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
              :key="index"
            >
              <v-skeleton-loader
                class="mx-auto"
                type="card"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <div
            v-if="eventList.length == 0"
            class="pa-4 d-flex flex-column align-center justify-center"
          >
            <v-icon style="font-size: 3rem">mdi-view-grid</v-icon>
            <span class="body-1 font-weight-light mt-4"
              >No se encontraron resultados</span
            >
          </div>
          <v-row v-else class="pa-4 pt-0">
            <v-col
              cols="12"
              md="6"
              v-for="(eventItem, index) of eventList"
              :key="index"
            >
              <EventListItem :event="eventItem"></EventListItem>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-container>
    <v-img :src="apanao" height="200" full-width></v-img>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import EventListItem from "../Event/EventListItem";
import EventCardGraphs from "../Event/EventCardGraphs";
import OrganismProfilePicture from "@/components/Organism/OrganismProfilePicture";
import { format, parseISO, formatISO, startOfYear, addMinutes } from "date-fns";
import { es } from "date-fns/esm/locale";
import SvgIcon from "@/components/SvgIcon";
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    OrganismProfilePicture,
    EventListItem,
    EventCardGraphs,
    SvgIcon
  },
  data: () => ({
    apanao: require("@/assets/apanao.jpg"),
    pejeperra: require("@/assets/pejeperra.png"),
    eventList: [],
    zoom: 8,
    loading: false,
    center: { lat: -33.0055093, lng: -71.6002957 },
    filterData: {
      polygonCoordinates: null,
      coordinates: null,
      eventDate: [],
      organism: []
    },
    polygonSearchOptions: {
      color: "#000000"
    },
    polygonCreateLayer: null,
    polygonEditLayer: null,
    menuDatePicker: false,
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    _timerId: false,
    _organismAutocompletetimerId: false,
    searchTextOrganism: "",
    organismList: [],
    listGraphs: {}
  }),
  methods: {
    async getOrganismList() {
      try {
        let { data: list } = await this.$http.get("organism", {
          params: {
            where: {
              searchText: {
                contains: (this.searchTextOrganism || "").toLowerCase()
              },
              validated: true
            },
            sort: "ocurrenceFrecuency DESC",
            limit: 10
          }
        });
        this.organismList = [...this.filterData.organism, ...list];
      } catch (err) {
        console.log(err);
      }
    },
    removeOrganismList(organism) {
      this.filterData.organism = this.filterData.organism.filter(
        ({ id }) => id != organism.id
      );
    },
    async getData() {
      if (this.filterData.polygonCoordinates) {
        this.findWithinList();
      } else {
        this.findWithinBox();
      }
    },
    boundsUpdated(bounds) {
      this.filterData = {
        ...this.filterData,
        coordinates: [
          [bounds.getNorthEast().lng, bounds.getNorthEast().lat],
          [bounds.getSouthWest().lng, bounds.getSouthWest().lat]
        ]
      };
    },
    cleanFilter() {
      this.filterData = {
        ...this.filterData,
        eventDate: [],
        organism: []
      };
      this.stopDrawer();
    },
    async findWithinBox() {
      try {
        this.loading = true;
        let { coordinates, eventDate, organism } = this.filterData;
        if (!coordinates) {
          throw new Error("Faltan parámetros");
        }

        let { data: eventList } = await this.$http.post("event/findwithinBox", {
          coordinates: coordinates,
          eventDate: eventDate,
          organism: organism.map(({ id }) => id)
        });
        this.eventList = eventList[0] || [];
        this.listGraphs = eventList[1];
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    async findWithinList() {
      try {
        this.loading = true;
        let { polygonCoordinates, eventDate, organism } = this.filterData;

        if (!polygonCoordinates) {
          throw new Error("Faltan parámetros");
        }

        let { data: eventList } = await this.$http.post("event/findwithin", {
          coordinates: polygonCoordinates,
          eventDate: eventDate,
          organism: organism.map(({ id }) => id)
        });
        this.eventList = eventList[0] || [];
        this.listGraphs = eventList[1];
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    startControl() {
      let map = this.$refs.map.mapObject;
      const color = "#000000";

      var editableLayers = new L.FeatureGroup();
      map.addLayer(editableLayers);
      var drawControl = new L.Control.Draw({
        draw: {
          polygon: {
            allowIntersection: false, // Restricts shapes to simple polygons
            drawError: {
              color: "#e1e100", // Color the shape will turn when intersects
              message: "<strong>Oh snap!<strong> you can't draw that!" // Message that will show when intersect
            },
            shapeOptions: {
              color: "#bada55"
            }
          },
          polyline: false,
          circle: false,
          rectangle: false,
          marker: false
        },
        edit: {
          featureGroup: editableLayers,
          edit: true
        }
      });

      map.addControl(drawControl);
    },
    onEdit(e) {
      this.filterData.polygonCoordinates = e.target.toGeoJSON().geometry.coordinates;
    },
    onCreated(e) {
      // Deshabilitar capa de creación de polígonos
      this.polygonCreateLayer.disable();

      // Habilitar capa de edición de polígonos
      this.polygonEditLayer = new L.Polygon(e.layer.getLatLngs(), {
        color: this.polygonSearchOptions.color
      });

      this.polygonEditLayer.editing.enable();

      this.polygonEditLayer.on("edit", this.onEdit);

      this.$refs.map.mapObject.addLayer(this.polygonEditLayer);

      this.filterData.polygonCoordinates = e.layer.toGeoJSON().geometry.coordinates;
    },
    async startDrawer() {
      let map = this.$refs.map.mapObject;
      const color = "#000000";

      // Primera definición de capa para creación de polígonos
      this.polygonCreateLayer = new L.Draw.Polygon(map, {
        allowIntersection: false,
        drawError: {
          color: "#e1e100"
        },
        shapeOptions: {
          color: color
        },
        color: color
      });

      // Habilitar la capa de creación de polígonos
      this.polygonCreateLayer.enable();

      // Captura de evento, cancelación de creación de polígonos
      map.on("draw:canceled", function(e) {});

      // Captura de evento, finalización de creación de polígonos
      map.on("draw:created", this.onCreated);
    },
    async getLocation() {
      try {
        let positionSuccess = await new Promise((res, rej) =>
          navigator.geolocation.getCurrentPosition(res, rej)
        );
        let { latitude, longitude } = positionSuccess.coords;
        this.center = {
          lat: latitude,
          lng: longitude
        };
        this.zoom = 13;
      } catch (err) {
        console.log(err);
        this.zoom = 11;
      }
    },
    stopDrawer() {
      this.filterData = {
        ...this.filterData,
        polygonCoordinates: null
      };
      this.$refs.map.mapObject.removeLayer(this.polygonEditLayer);
      this.$refs.map.mapObject.removeLayer(this.polygonCreateLayer);
      this.polygonEditLayer = null;
      this.polygonCreateLayer = null;
    }
  },
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    },
    computedDateFormattedDatefns() {
      let [from, to] = this.filterData.eventDate;
      if (!from && !to) {
        return "";
      }
      return (
        (from
          ? format(
              addMinutes(new Date(from), new Date(from).getTimezoneOffset()),
              "dd/MM/yyyy"
            )
          : "--") +
        " al " +
        (to
          ? format(
              addMinutes(new Date(to), new Date(to).getTimezoneOffset()),
              "dd/MM/yyyy"
            )
          : "--")
      );
    },
    markerList() {
      return (this.eventList || [])
        .filter(el => el.coordinates)
        .map(el => ({
          id: el.id,
          latLng: el.coordinates.reverse()
        }));
    }
  },
  watch: {
    filterData: {
      deep: true,
      handler() {
        clearTimeout(this._timerId);
        this._timerId = setTimeout(() => {
          this.getData();
        }, 2000);
      }
    },
    searchTextOrganism() {
      clearTimeout(this._organismAutocompletetimerId);
      this._organismAutocompletetimerId = setTimeout(() => {
        this.getOrganismList();
      }, 800);
    }
  },
  mounted() {
    this.$refs.map.mapObject._onResize();

    var bingLayer = L.tileLayer
      .bing({
        bingMapsKey:
          "AqZzddAfYuAhbM8Ez9sYiA81Of7Y9xM2idIEFhDH7nc_897g4AMq4TpnKvdmP0To",
        imagerySet: "AerialWithLabels"
      })
      .addTo(this.$refs.map.mapObject);

    this.getLocation();
  }
};
</script>

<style>
.map-marker {
  fill: blue;
}
</style>
